import { encode } from 'string-encode-decode';

export default function setUserAuth(data) {
  sessionStorage.setItem('app-web-user-access-token', encode(JSON.stringify(data)));
}
